import React, { useState } from "react";
import PropTypes from "prop-types";
import { Tabs, Tab } from "@material-ui/core";
import PaletteIcon from "@material-ui/icons/Palette";
import TextFieldsIcon from "@material-ui/icons/TextFields";
import M_ThemeSelector from "../M_ThemeSelector/M_ThemeSelector";
import M_FontSelector from "../M_FontSelector/M_FontSelector";
import "./M_Preferences.css";

const TABS = {
  THEME: 0,
  FONT: 1,
};

const PANELS = {
  [TABS.THEME]: M_ThemeSelector,
  [TABS.FONT]: M_FontSelector,
};

const M_Preferences = (props) => {
  const { initialTab } = props;
  const [activeTab, setActiveTab] = useState(initialTab);

  const handleChange = (event, value) => setActiveTab(value);

  return (
    <div className="m-preferences">
      <Tabs
        value={activeTab}
        onChange={handleChange}
        className="m-preferences__tabs"
        indicatorColor="primary"
        textColor="primary"
        aria-label="Preferences tabs"
      >
        <Tab
          label={
            <span className="m-preferences__tab-label">
              <PaletteIcon fontSize="small" /> Theme
            </span>
          }
        />
        <Tab
          label={
            <span className="m-preferences__tab-label">
              <TextFieldsIcon fontSize="small" /> Font & display
            </span>
          }
        />
      </Tabs>

      <div className="m-preferences__panel" role="tabpanel">
        {React.createElement(PANELS[activeTab] || M_ThemeSelector)}
      </div>
    </div>
  );
};

M_Preferences.defaultProps = {
  initialTab: TABS.THEME,
};

M_Preferences.propTypes = {
  initialTab: PropTypes.number,
};

export default M_Preferences;
